import gql from "graphql-tag";

export const GET_PROJECTLAYERS = gql`
query { 
  projectLayers {
    id
    name
    comments
    source
    layers
    project { 
        id, 
        name,
        organization { id, name }
        }
    ignore
    showByDefault
    created
    lastModified
  }
}
`;

export const GET_PROJECT_LAYERS_FOR_PROJECT = gql`
query ProjectLayersForProject($projectId: Float!){ 
    projectLayers: projectLayersForProject(projectId: $projectId) {
    id
    name
    comments
    source
    layers
    project { 
        id, 
        name,
        organization { id, name }
        }
    ignore
    showByDefault
    created
    lastModified
  }
}
`;

export const ADD_PROJECTLAYER = gql`
mutation createProjectLayer ($name: String!, $ignore: Boolean!, $showByDefault: Boolean!, $comments: String!, $source: String!, $layers: String!, $projectId: Float!) {
      createProjectLayer(projectLayer: {
        name: $name
        comments: $comments
        ignore:$ignore
        showByDefault:$showByDefault
        projectId:$projectId
        source:$source
        layers:$layers
      }
    ) {
        id name ignore showByDefault comments source layers
        project { 
        id, 
        name,
        organization { id, name }
        }
        created
        lastModified
    }
  }
`;

export const UPDATE_PROJECTLAYER = gql`
    mutation updateProjectLayer ($id: ID!, $name: String!, $ignore: Boolean!, $showByDefault: Boolean!, $comments: String!, $source: String!, $layers: String!, $projectId: Float!) {
      updateProjectLayer(projectLayer: {
        id: $id
        name: $name
        comments: $comments
        ignore:$ignore
        showByDefault:$showByDefault
        projectId:$projectId
        source:$source
        layers:$layers
      }
    ) {
        id name ignore showByDefault comments source layers
        project { 
        id, 
        name,
        organization { id, name }
        }
        created
        lastModified
    }
}
`;

export const DELETE_PROJECTLAYER = gql`
mutation deleteProjectLayer ($id: Float!) {
    deleteProjectLayer(id: $id) 
}
`;

export const GET_PANORAMA_ZIP_UPLOAD_URL = gql`
query getPanoramaZipUploadUrl($projectId: Float!, $scanName: String!) {
    getPanoramaZipUploadUrl(projectId: $projectId, scanName: $scanName) {
        uploadUrl
        s3Uri
    }
}
`;

export const GET_PANORAMA_ZIP_MULTIPART_INFO = gql`
query getPanoramaZipMultipartInfo($projectId: Float!, $scanName: String!, $numberOfParts: Float!) {
    getPanoramaZipMultipartInfo(projectId: $projectId, scanName: $scanName, numberOfParts: $numberOfParts) {
        filename
        uploadId
        parts {
            eTag
            partNumber
            signedUrl
        }
    }
}
`;

export const COMPLETE_PANORAMA_ZIP_MULTIPART = gql`
mutation completePanoramaZipMultipart($projectId: Float!, $scanName: String!, $uploadId: String!, $eTags: String!) {
    completePanoramaZipMultipart(projectId: $projectId, scanName: $scanName, uploadId: $uploadId, eTags: $eTags)
}
`;

export const GET_PANORAMA_RAW_ZIP_UPLOAD_URL = gql`
query getPanoramaRawZipUploadUrl($projectId: Float!, $scanName: String!) {
    getPanoramaRawZipUploadUrl(projectId: $projectId, scanName: $scanName) {
        uploadUrl
        s3Uri
    }
}
`;

export const GET_PANORAMA_RAW_ZIP_MULTIPART_INFO = gql`
query getPanoramaRawZipMultipartInfo($projectId: Float!, $scanName: String!, $numberOfParts: Float!) {
    getPanoramaRawZipMultipartInfo(projectId: $projectId, scanName: $scanName, numberOfParts: $numberOfParts) {
        filename
        uploadId
        parts {
            eTag
            partNumber
            signedUrl
        }
    }
}
`;

export const COMPLETE_PANORAMA_RAW_ZIP_MULTIPART = gql`
mutation completePanoramaRawZipMultipart($projectId: Float!, $scanName: String!, $uploadId: String!, $eTags: String!) {
    completePanoramaRawZipMultipart(projectId: $projectId, scanName: $scanName, uploadId: $uploadId, eTags: $eTags)
}
`;

export const PROCESS_PANORAMA_UPLOADED_ZIP = gql`
mutation processPanoramaUploadedZip($projectId: Float!, $scanName: String!, $layerName: String, $comments: String) {
    processPanoramaUploadedZip(projectId: $projectId, scanName: $scanName, layerName: $layerName, comments: $comments)
}
`;

export const CREATE_PANORAMA_LAYER = gql`
mutation createPanoramaLayer($projectId: Float!, $scanName: String!, $layerName: String!, $comments: String) {
    createPanoramaLayer(projectId: $projectId, scanName: $scanName, layerName: $layerName, comments: $comments) {
        id name ignore showByDefault comments source layers
        project {
            id,
            name,
            organization { id, name }
        }
        created
        lastModified
    }
}
`;
